export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VerticalLabelComponent.vue?vue&type=template&id=f132c158&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/VerticalLabelComponent.vue?vue&type=template&id=f132c158&scoped=true&
// module id = 309
// module chunks = 0